export const TRANSACTION_HISTORY = "TRANSACTION_HISTORY";
export const TRANSACTION_HISTORY_FILTER = "TRANSACTION_HISTORY_FILTER";
export const TRANSACTION_HISTORY_SEARCH = "TRANSACTION_HISTORY_SEARCH";
export const TRANSACTION_HISTORY_SORT = "TRANSACTION_HISTORY_SORT";
export const TRANSACTION_HISTORY_EDITABLE = "TRANSACTION_HISTORY_EDITABLE";
export const TRANSACTION_HISTORY_ALL_TXNS = "TRANSACTION_HISTORY_ALL_TXNS";
export const TRANSACTION_HISTORY_ALL_TXNS_LOADER = "TRANSACTION_HISTORY_ALL_TXNS_LOADER";
export const TRANSACTION_HISTORY_ALL_TXNS_ERROR = "TRANSACTION_HISTORY_ALL_TXNS_ERROR";
export const TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR = "TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR";
